import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user) return null;

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { to: '/', label: 'Dashboard' },
    { to: '/upload', label: 'Upload & Audit' },
    { to: '/audits', label: 'Audit History' },
  ];

  return (
    <nav className="bg-gradient-to-r from-teal-700 via-teal-800 to-brand-700 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center">
              <img
                src="/chart-auditer-ai-logo.svg"
                alt="Chart Auditer AI logo"
                className="h-10 w-auto object-contain"
              />
            </Link>
            <div className="flex space-x-1">
              {navLinks.map(link => (
                <Link key={link.to} to={link.to}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition ${
                    isActive(link.to)
                      ? 'bg-white/20 text-white'
                      : 'text-teal-100 hover:bg-white/10 hover:text-white'
                  }`}>
                  {link.label}
                </Link>
              ))}
              {user.role === 'super_admin' && (
                <Link to="/admin"
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition ${
                    isActive('/admin')
                      ? 'bg-yellow-500/30 text-yellow-200'
                      : 'text-yellow-300 hover:bg-yellow-500/20 hover:text-yellow-200'
                  }`}>
                  Admin
                </Link>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <div className="text-right">
              <span className="text-teal-100 text-sm block">{user.firstName} {user.lastName}</span>
              <span className="text-teal-300/70 text-xs">{user.agencyName}
                {user.accountType === 'consultant' && (
                  <span className="ml-1 bg-purple-500/30 text-purple-200 px-1.5 py-0.5 rounded text-xs">Consultant</span>
                )}
              </span>
            </div>
            <button onClick={handleLogout}
              className="bg-white/15 hover:bg-white/25 border border-white/20 px-3 py-1.5 rounded-lg text-sm font-medium transition">
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
